<template>
  <div ref="whole_page" class="w-full">
    <div class="mt-4 w-full">
      <div v-if="classrooms.length > 0" >
        <ul v-if="!selectedClassroom.companyId" style="flex-wrap: wrap;">
          <div class="vx-row mb-5">
            <div class="vx-col">
              <div class="flex" style="align-items: baseline;">
                <div class="mr-2 flex" style="height: 16px">
                  <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="limit-width_fixed-scalable" style="text-align: left;">
            <li>
              <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text glow-effect_bg-color__blend bg-color">
                      <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <vs-button
                    :disabled="true"
                    size="large"
                    class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                    type="filled"
                    color="">
                    Select a Classroom
                  </vs-button>
                </vx-input-group>
              </vx-card>
            </li>
          
            <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
              <li v-for="(_classroom, index) in classrooms" :key="index" class="mb-3">
                <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                        <img height="29" :src="getIcon(_classroom.companyId)" />
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0;"
                      @click="selectClassroom(_classroom)">
                      {{ _classroom.courseName + " - " + _classroom.companyName }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </ul>
          </div>
        </ul>

        <div v-if="selectedClassroom.companyId && !selectedModule.id" >
          <div class="vx-row mb-5">
            <div class="vx-col">
              <div class="flex" style="align-items: baseline;">
                <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="backToSelectSubject">
                  <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex" style="height: 16px">
                  <img class="mr-1 h-4 w-4" :src="getIcon(selectedClassroom.courseId)" />
                  <h6>{{ selectedClassroom.courseName }} - {{ selectedClassroom.companyName }}</h6>
                </div>
              </div>
            </div>
          </div>

          <ul style="flex-wrap: wrap;" class="mt-2">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                      type="filled"
                      color="">
                      Select a Module
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            
              <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
                <li v-for="(_module, index) in modules" :key="index" class="mb-3">
                  <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                          <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0;"
                        @click="selectModule(_module)">
                        {{ _module.name }}
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
                </li>
              </ul>
            </div>
          </ul>
        </div>

        <div v-if="selectedModule.id && !selectedTopic.id" >
          <div class="vx-row mb-5">
            <div class="vx-col">
              <div class="flex" style="align-items: baseline;">
                <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="backToSelectSubject">
                  <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectModule">
                  <img class="mr-1 h-4 w-4" :src="getIcon(selectedClassroom.courseId)" />
                  <h6>{{ selectedClassroom.courseName }} - {{ selectedClassroom.companyName }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex" style="height: 16px">
                  <span><feather-icon class="mr-1" icon="CodesandboxIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedModule.name }}</h6>
                </div>
              </div>
            </div>
          </div>

          <ul style="flex-wrap: wrap;" class="mt-2">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                      type="filled"
                      color="">
                      Select a Topic in a Term
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            
              <li v-for="(_term, termIndex) in terms" :key="termIndex" class="mb-3 mr-3">
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-term bg-color"
                      style="border-radius:0 7px 7px 0;"
                      type="filled"
                      color="">
                      {{ _term.name }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>

                <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
                  <li v-for="(_topic, topicIndex) in topics.filter(function(item){return item.termId == _term.id})" :key="topicIndex" class="mb-3">
                    <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                            <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button
                          size="large"
                          class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                          style="border-radius:0 7px 7px 0;"
                          @click="selectTopic(_topic)">
                          {{ _topic.name }}
                        </vs-button>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </li>
            </div>
          </ul>
        </div>

        <div v-if="$getSiteId() != 21 && selectedTopic.id && !selectedAssessment.taskId" >
          <div class="vx-row mb-5">
            <div class="vx-col">
              <div class="flex" style="align-items: baseline;">
                <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="backToSelectSubject">
                  <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectModule">
                  <img class="mr-1 h-4 w-4" :src="getIcon(selectedClassroom.courseId)" />
                  <h6>{{ selectedClassroom.courseName }} - {{ selectedClassroom.companyName }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectTopic">
                  <span><feather-icon class="mr-1" icon="CodesandboxIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedModule.name }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex" style="height: 16px">
                  <span><feather-icon class="mr-1" icon="DiscIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedTopic.name }}</h6>
                </div>
              </div>
            </div>
          </div>

          <ul style="flex-wrap: wrap;" class="mt-2">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                      type="filled"
                      color="">
                      Select an Assessment
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>

              <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
                <li v-for="(_task, index) in distinctAssessments" :key="index" class="mb-3">
                  <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                          <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0;"
                        @click="selectAssessment(_task)">
                        <p>{{ _task.taskName }}</p>
                        <small><p>{{ `${_task.taskType} [${_task.taskDisplayId}]` }}</p></small>
                      </vs-button>

                      <template slot="append">
                        <div class="append-text input-group_prepend-slot-bg" style="border-radius: 0 5px 5px 0 !important;width: 55px;justify-content: space-around;">
                          <span><h3>{{ _task.studentCount }}</h3></span>
                        </div>
                      </template>
                    </vx-input-group>
                  </vx-card>
                </li>
              </ul>
            </div>
          </ul>
        </div>

        <div v-if="$getSiteId() == 21 && selectedTopic.id && !selectedAssessment.taskId" >
          <div class="vx-row mb-5">
            <div class="vx-col">
              <div class="flex" style="align-items: baseline;">
                <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="backToSelectSubject">
                  <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectModule">
                  <img class="mr-1 h-4 w-4" :src="getIcon(selectedClassroom.courseId)" />
                  <h6>{{ selectedClassroom.courseName }} - {{ selectedClassroom.companyName }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectTopic">
                  <span><feather-icon class="mr-1" icon="CodesandboxIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedModule.name }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex" style="height: 16px">
                  <span><feather-icon class="mr-1" icon="DiscIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedTopic.name }}</h6>
                </div>
              </div>
            </div>
          </div>
          <!-- Assessments -->
          <ul v-if="distinctAssessments.filter(q=> q.isAssessment == true).length>0" style="flex-wrap: wrap;" class="mt-2">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                      type="filled"
                      color="">
                      Select an Assessment
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>

              <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
                <li v-for="(_task, index) in distinctAssessments.filter(q=> q.isAssessment == true)" :key="index" class="mb-3">
                  <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                          <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0;"
                        @click="selectAssessment(_task)">
                        <p>{{ _task.taskName }}</p>
                        <small><p>{{ `${_task.taskType} [${_task.taskDisplayId}]` }}</p></small>
                        <small><p>Assessment</p></small>
                      </vs-button>

                      <template slot="append">
                        <div class="append-text input-group_prepend-slot-bg" style="border-radius: 0 5px 5px 0 !important;width: 55px;justify-content: space-around;">
                          <span><h3>{{ _task.studentCount }}</h3></span>
                        </div>
                      </template>
                    </vx-input-group>
                  </vx-card>
                </li>
              </ul>
            </div>
          </ul>
          <!-- Classwork -->
          <ul v-if="distinctAssessments.filter(q=> q.isAssessment == false).length>0" style="flex-wrap: wrap;" class="mt-2">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                      type="filled"
                      color="">
                      Select a Classwork item
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>

              <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
                <li v-for="(_task, index) in distinctAssessments.filter(q=>q.isAssessment == false)" :key="index" class="mb-3">
                  <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                          <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0;"
                        @click="selectAssessment(_task)">
                        <p>{{ _task.taskName }}</p>
                        <small><p>{{ `${_task.taskType} [${_task.taskDisplayId}]` }}</p></small>
                        <small><p>Classwork</p></small>
                      </vs-button>

                      <template slot="append">
                        <div class="append-text input-group_prepend-slot-bg" style="border-radius: 0 5px 5px 0 !important;width: 55px;justify-content: space-around;">
                          <span><h3>{{ _task.studentCount }}</h3></span>
                        </div>
                      </template>
                    </vx-input-group>
                  </vx-card>
                </li>
              </ul>
            </div>
          </ul>
        </div>

        <div v-if="selectedAssessment.taskId && !selectedStudent.studentId" >
          <div class="vx-row mb-5">
            <div class="vx-col">
              <div class="flex" style="align-items: baseline;">
                <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="backToSelectSubject">
                  <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectModule">
                  <img class="mr-1 h-4 w-4" :src="getIcon(selectedClassroom.companyId)" />
                  <h6>{{ selectedClassroom.courseName }} - {{ selectedClassroom.companyName }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectTopic">
                  <span><feather-icon class="mr-1" icon="CodesandboxIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedModule.name }}</h6>
                </div>
                <h6>/</h6>
                <div class="mx-2 flex cursor-pointer" style="height: 16px" @click="backToSelectAssessment">
                  <span><feather-icon class="mr-1" icon="DiscIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                  <h6>{{ selectedTopic.name }}</h6>
                </div>
              </div>
            </div>
          </div>

          <ul style="flex-wrap: wrap;" class="mt-2">
            <div style="text-align: left;">
              <li>
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_bg-color__blend bg-color">
                        <span><feather-icon class="pt-1" icon="EditIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                      type="filled"
                      color="">
                      Assessment: <strong>{{ selectedAssessment.taskName }}</strong>
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>
          </ul>

          <div class="vx-row">
            <div class="vx-col w-1/2">
              <div class="flex items-center justify-end">
                <h3>Activity</h3>
                <vue-apex-charts height="300" :options="activityChartOptions" :series="activityChartOptions.series" />
              </div>
            </div>
            <div class="vx-col w-1/2">
              <div class="flex items-center justify-start">
                <h3>Average</h3>
                <vue-apex-charts height="300" :options="averageChartOptions" :series="averageChartOptions.series" />
              </div>
            </div>
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col text-left">
              <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text glow-effect_bg-color__blend bg-color">
                      <span><feather-icon class="pt-1" icon="UsersIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <vs-button
                    :disabled="true"
                    size="large"
                    class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                    type="filled"
                    color="">
                    Select a Student
                  </vs-button>
                </vx-input-group>
              </vx-card>
            </div>
            <vs-spacer/>
            <div class="vx-col self-center text-left">
              <div class="vx-row">
                <div class="vx-col self-center">
                  <vs-button @click="refreshAssessments" icon-pack="feather" icon="icon-refresh-ccw" color="success" radius/>
                </div>
                <div class="vx-col self-center">
                  <vs-checkbox v-model="showOnlyCompleted">Show Only Completed</vs-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div id="prototype" class="vx-row">
            <div class="vx-col mb-3" v-for="(_assessment, index) in assessmentStudents" :key="index" style="min-width: 210px;max-width: 210px;">
              <vx-card style="border-radius: 90px 90px 30px 30px;" class="hover_on-mouseover" @click="openAssessment(_assessment)">
                <div slot="no-body">
                  <img id="card-img" src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" alt="content-img" class="responsive card-img-top" />
                </div>
                <div style="overflow: hidden;height: 65px;">
                  <h5 class="mb-2">{{ _assessment.studentName }}</h5>
                </div>
                <span class="flex mb-2" style="align-items: center;">
                  <feather-icon icon="CheckIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>
                  <vs-progress v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" :height="16" :percent="(_assessment.achievedMarks / _assessment.totalMarks) * 100" show-value color="success" style="text-align: start;"/>
                  <p v-if="(_assessment.totalMarks != null && _assessment.achievedMarks != null)" class="ml-2" style="margin-top: -0.1rem !important; width:23px">
                    <strong>{{ _assessment.totalMarks ? `${Math.round((_assessment.achievedMarks / _assessment.totalMarks) * 100, 2)}%` : "0%" }}</strong>
                  </p>
                  <div class="w-full" v-else>
                    <p>
                      <strong>N/A</strong>
                    </p>
                  </div>
                </span>
                <span class="flex" style="align-items: center;"><feather-icon icon="ClockIcon" class="pr-1" svg-classes="stroke-current"></feather-icon>{{ _assessment.completedDate.replace("T", " ").split('.')[0] }}</span>
                <vs-spacer />
                <div class="w-full" style="height: 18px;">
                  <vs-chip class="w-full mt-1" :color="_assessment.statusId == 1 ? 'success' : 'primary'">{{_assessment.statusDisplayName == 'Completed' && $getSiteId() == 21 ? 'Submitted' :_assessment.statusDisplayName  }}</vs-chip>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
      <p v-else-if="showMessage" style="color:white;font-weight:500;font-size:16px;padding-top:5px">Oops! Looks like you don't have any classrooms with student assessments...</p>
    </div>
  </div>
</template>


<script>
import defaultIcon from '@/digicampus/assets/subjecticons/default.svg'
import mathsIcon from '@/digicampus/assets/subjecticons/maths.svg'
import mathsliteracyIcon from '@/digicampus/assets/subjecticons/maths-literacy.svg'
import afrikaanshomeIcon from '@/digicampus/assets/subjecticons/afrikaans-home.svg'
import afrikaansfirstIcon from '@/digicampus/assets/subjecticons/afrikaans-first.svg'
import englishhomeIcon from '@/digicampus/assets/subjecticons/english-home.svg'
import englishfirstIcon from '@/digicampus/assets/subjecticons/english-first.svg'
import lifeskillsIcon from '@/digicampus/assets/subjecticons/life-skills.svg'
import lifesciencesIcon from '@/digicampus/assets/subjecticons/life-sciences.svg'
import socialscienceIcon from '@/digicampus/assets/subjecticons/social-science.svg'
import lifeorientationIcon from '@/digicampus/assets/subjecticons/life-orientation.svg'
import naturalscienceandtechnologyIcon from '@/digicampus/assets/subjecticons/natural-science-and-technology.svg'
import geographyIcon from '@/digicampus/assets/subjecticons/geography.svg'
import economicsIcon from '@/digicampus/assets/subjecticons/economics.svg'
import accountingIcon from '@/digicampus/assets/subjecticons/accounting.svg'
import tourismIcon from '@/digicampus/assets/subjecticons/tourism.svg'
import naturalscienceIcon from '@/digicampus/assets/subjecticons/natural-science.svg'
import historyIcon from '@/digicampus/assets/subjecticons/history.svg'
import egdIcon from '@/digicampus/assets/subjecticons/eng-graphics-and-design.svg'
import technologyIcon from '@/digicampus/assets/subjecticons/technology.svg'
import computerapptechnologyIcon from '@/digicampus/assets/subjecticons/computer-app-technology.svg'
import itIcon from '@/digicampus/assets/subjecticons/it.svg'
import electricaltechnologyIcon from '@/digicampus/assets/subjecticons/electrical-technology.svg'
import mechanicaltechnologyIcon from '@/digicampus/assets/subjecticons/mechanical-technology.svg'
import civiltechnologyIcon from '@/digicampus/assets/subjecticons/civil-technology.svg'
import businessstudiesIcon from '@/digicampus/assets/subjecticons/business-studies.svg'
import consumerstudiesIcon from '@/digicampus/assets/subjecticons/consumer-studies.svg'
import physicalscienceIcon from '@/digicampus/assets/subjecticons/physical-science.svg'
import chessIcon from '@/digicampus/assets/subjecticons/chess.svg'
import creativeartsIcon from '@/digicampus/assets/subjecticons/creative-arts.svg'

import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      activityChartOptions: {
        chart: {
            type: 'radialBar',
        },
        series: [],
        labels: ['Complete'],
        colors: [this.$_primary],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: "60%",
              background: "#293450"
            },
            track: {
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                blur: 4,
                opacity: 0.2
              }
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: "#fff",
                fontSize: "13px"
              },
              value: {
                color: "#fff",
                fontSize: "30px",
                show: true
              }
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            gradientToColors: [this.$_tertiary],
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: "round"
        },
      },
      averageChartOptions: {
        chart: {
            type: 'radialBar',
        },
        series: [],
        labels: ['Score'],
        colors: [this.$_primary],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: "60%",
              background: "#293450"
            },
            track: {
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                blur: 4,
                opacity: 0.2
              }
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: "#fff",
                fontSize: "13px"
              },
              value: {
                color: "#fff",
                fontSize: "30px",
                show: true
              }
            }
          }
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            gradientToColors: [this.$_tertiary],
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: "round"
        },
      },
      classrooms: [],
      showMessage: false,
      moduleData: [],
      modules: [],
      selectedClassroom: {},
      selectedModule: {},
      terms: [],
      topics: [],
      selectedTopic: {},
      selectedAssessment: {},
      allAssessments: [],
      distinctAssessments: [],
      origAssessmentStudents: [],
      assessmentStudents: [],
      selectedStudent: {},
      showOnlyCompleted: false,
      math: [38,39,47,51,54,55,56,57,58,59,89,130,139,141,143,145,148,150,176,189,196,225,236,248,259,261,341,361,367,380,388,389,398,400,408,412,417],
      mathLit: [44,115,124,266,268,269,349,368,393],
      afrHuis: [40,41,60,61,62,63,165,201,202,204,250,252,258],
      afrEat: [46,64,78,80,91,200,206,211,213,238,239,240,676],
      engHome: [52,90,92,98,100,131,215,228,232,235,244,245,246],
      engFal: [53,81,82,83,132,163,192,193,195,241,242,243,332,343,370,390,399,518],
      lifeSkill: [45,49,79,88,103,104,109,110,197,198,334,409,410,414,421],
      lifeScience: [48,106,113,310,311,313,359,371,395],
      socScience: [71,72,116,117,118,119,126,184,186,187,205,207],
      lifeOrient: [84,85,86,154,155,157,249,251,253,255,256,257,527],
      natSciTech: [42,50,74,77,185,191],
      geography: [94,95,96,97,99,105,344,378,391],
      econManSci: [120,122,125,175,177,178],
      economics: [128,133,135,229,230,231,354,376,394],
      accounting: [136,138,146,210,212,216,345,373,392],
      tourism: [156,158,160,180,199,348,372,403,511,512,513],
      natScience: [111,112,114,181,182,183],
      history: [140,142,144,147,149,151,342,374,404,429],
      egd: [127,129,134,260,263,267],
      tech: [171,172,174,188,190,194],
      compAppTech: [137,152,161,214,220,223],
      it: [164,167,179,270,271,272],
      elecTech: [291,292,293],
      mechTech: [315,316,317],
      civilTech: [318,319,320],
      busStudy: [153,159,166,219,221,222,346,365,405,495,506,507],
      consStud: [168,170,173,233,234,237],
      physScience: [208,209,218,224,226,227,347,369,397],
      chess: [335,336,337,338],
      agriSci: [350,366,402],
      arts: [362],
      isixhosa: [333,352,387,401],
    };
  },
  watch: {
    showOnlyCompleted: function(val) {
      var self = this;

      if (val) {
        self.assessmentStudents = self.origAssessmentStudents.filter(x => x.statusId == 1);
      }
      else {
        self.assessmentStudents = self.origAssessmentStudents;
      }
    }
  },
  computed: {
    
  },
  methods: {
    getClassrooms() {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');
      
      var onSuccess = function(response) {
        if (response.data && response.data.length > 0) {
          self.classrooms = response.data.sort((a, b) =>
            a.companyName > b.companyName ? 1 : -1
          );
        }
        else {
          self.showMessage = true;
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, "Company/ListTeacherClassroomsForAssessment", onSuccess, onFinally);
    },
    selectClassroom(classroom) {
      this.selectedClassroom = classroom;
      this.selectedClassroom.icon = this.getIcon(classroom.companyId);

      this.getModuleData()
    },
    getModuleData() {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');

      var onSuccess = function(response) {
        if (response.data && response.data.length >= 0) {
          self.moduleData = response.data;
          var temp_modules = [];

          self.modules = [];

          temp_modules = self.moduleData.map(function(item) {
            return {
              id: item.moduleCategoryId,
              name: item.moduleCategoryName,
              termId: item.moduleGroupId
            };
          });

          temp_modules.forEach(_module => {
            if (
              self.modules.filter(function(item) {
                return _module.id == item.id;
              }).length == 0 && _module.id != null
            )
              self.modules.push(_module);
          });

          self.modules = self.modules.sort((a, b) => a.name > b.name ? 1 : -1);
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };
      self.$ajaxGet(self, "Company/Teacher/GetModuleData?classroomId=" + self.selectedClassroom.companyId + "&courseId="+self.selectedClassroom.courseId, onSuccess, onFinally);
    },
    selectModule(module) {
      this.selectedModule = module;
      this.getTermsAndTopics();
    },
    getTermsAndTopics() {
      var self = this;

      var temp_terms = [];

      temp_terms = self.moduleData.map(function(item) {
        return { id: item.moduleGroupId, name: item.moduleGroupName };
      });

      self.topics = self.moduleData.map(function(item) {
        return {
          id: item.id,
          name: item.name,
          description: item.description,
          moduleId: item.moduleCategoryId,
          termId: item.moduleGroupId,
          siteId: item.siteId
        };
      }).filter(function(item){ return item.moduleId == self.selectedModule.id });

      temp_terms.filter(function(item) {
        return self.topics.map(function(_topic) {
          return _topic.termId; 
        }).includes(item.id);
      }).forEach(_term => {
        if (self.terms.filter(function(item) {
          return _term.id == item.id
        }).length == 0 && _term.id != null)
          self.terms.push(_term);
      });

      self.terms = self.terms.sort(function (a, b) { return a.name > b.name ? 1 : -1; });
    },
    selectTopic(topic) {
      this.selectedTopic = topic;
      this.getAssessments();
    },
    getAssessments(whenDone) {
      var self = this;
      self.showLoadingOnElement('whole_page', 1, 'material');
      
      var onSuccess = function(response) {
        self.allAssessments = response.data;

        var temp_assessments = [];

        temp_assessments = self.allAssessments.map(item => {
          return {
            taskId: item.taskId,
            taskName: item.taskName,
            taskType: item.taskType,
            taskDisplayId: item.taskDisplayId,
            studentCount: 0,
            isClassroom: item.isClassroom,
            isAssessment: item.isAssessment
          };
        });

        temp_assessments.forEach(_assessment => {
          if (self.distinctAssessments.filter(item => {
            return _assessment.taskId == item.taskId
          }).length == 0) {
            _assessment.studentCount = temp_assessments.filter(x => x.taskId == _assessment.taskId).length;
            self.distinctAssessments.push(_assessment);
          }
        });
        self.distinctAssessments = self.distinctAssessments.sort((a, b) => { return a.taskName > b.taskName ? 1 : -1; });

        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, `Module/ListAssessmentsForModule?moduleId=${self.selectedTopic.id}&companyId=${self.selectedClassroom.companyId}`, onSuccess, onFinally);
    },
    selectAssessment(task) {
      var self = this;
      self.selectedAssessment = task;
      self.origAssessmentStudents = self.allAssessments.filter(item => {
        return item.taskId == task.taskId
      });
      
      self.origAssessmentStudents = self.origAssessmentStudents.sort((a, b) => { return a.completedOn > b.completedOn ? -1 : 1; });

      self.assessmentStudents = self.origAssessmentStudents;

      self.activityChartOptions.series = [Math.round(self.assessmentStudents[0].activityPercentage)];
      self.averageChartOptions.series = [Math.round(self.assessmentStudents[0].averagePercentage)];
    },
    refreshAssessments() {
      var self = this;
      self.showOnlyCompleted = false;
      self.getAssessments(function() {
        self.selectAssessment(self.selectedAssessment);
      });
    },
    openAssessment(_assessment) {
      let routeData = this.$router.resolve({ path: '/digi/teacher/viewassessment', query: { TaskLogId: _assessment.logId } });
      window.open(routeData.href, '_blank');
    },
    getIcon(id) {
      var self = this;
              
      if (self.math.includes(id))
        return mathsIcon;
      else if (self.mathLit.includes(id))
        return mathsliteracyIcon;
      else if (self.afrHuis.includes(id))
        return afrikaanshomeIcon;
      else if (self.afrEat.includes(id))
        return afrikaansfirstIcon;
      else if (self.engHome.includes(id))
        return englishhomeIcon;
      else if (self.engFal.includes(id))
        return englishfirstIcon;
      else if (self.lifeSkill.includes(id))
        return lifeskillsIcon;
      else if (self.lifeScience.includes(id))
        return lifesciencesIcon;
      else if (self.socScience.includes(id))
        return socialscienceIcon;
      else if (self.lifeOrient.includes(id))
        return lifeorientationIcon;
      else if (self.natSciTech.includes(id))
        return naturalscienceandtechnologyIcon;
      else if (self.geography.includes(id))
        return geographyIcon;
      else if (self.economics.includes(id))
        return economicsIcon;
      else if (self.accounting.includes(id))
        return accountingIcon;
      else if (self.tourism.includes(id))
        return tourismIcon;
      else if (self.natScience.includes(id))
        return naturalscienceIcon;
      else if (self.history.includes(id))
        return historyIcon;
      else if (self.egd.includes(id))
        return egdIcon;
      else if (self.tech.includes(id))
        return technologyIcon;
      else if (self.compAppTech.includes(id))
        return computerapptechnologyIcon;
      else if (self.it.includes(id))
        return itIcon;
      else if (self.elecTech.includes(id))
        return electricaltechnologyIcon;
      else if (self.mechTech.includes(id))
        return mechanicaltechnologyIcon;
      else if (self.civilTech.includes(id))
        return civiltechnologyIcon;
      else if (self.busStudy.includes(id))
        return businessstudiesIcon;
      else if (self.consStud.includes(id))
        return consumerstudiesIcon;
      else if (self.physScience.includes(id))
        return physicalscienceIcon;
      else if (self.chess.includes(id))
        return chessIcon;
      else if (self.arts.includes(id))
        return creativeartsIcon;
      else
        return defaultIcon;
    },
    getStatusColor(statusId) {
      var self = this;
      if(statusId == 1)
        return 'primary';
      else if(statusId == 5)
        return 'danger';
      else if(statusId == 13)
        return 'success';
      else if(statusId == 13)
        return 'warning';
      else if(statusId == 13)
        return 'warning';
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    backToSelectSubject() {
      this.selectedClassroom = {};
      this.modules = [];
      this.backToSelectModule();
    },
    backToSelectModule() {
      this.selectedModule = {};
      this.topics = [];
      this.terms = [];
      this.backToSelectTopic()
    },
    backToSelectTopic() {
      this.selectedTopic = {};
      this.allAssessments = [];
      this.distinctAssessments = [];
      this.backToSelectAssessment();
    },
    backToSelectAssessment() {
      this.selectedAssessment = {};
      this.assessmentStudents =  [];
    }
  },
  created() {
    
  },
  mounted() {
    this.getClassrooms();
  }
};
</script>

<style lang="scss">
  @import "../assets/main-digi.scss";
</style>
